<template>
  <div class="stock_index_detail" ref="contanier">
    <div ref="top_box" style="margin-bottom: 40px">
      <div class="stock_title">{{ $transform(baseInfo.name) }}</div>
      <div class="stock_name">{{ $transform(baseInfo.desc) }}</div>
      <div class="time">
        <span>{{ $transform("Last") }}</span> | {{ tableData.DATA }}
      </div>
      <!-- 12:44 PM AET -->
      <div class="stock_data">{{ tableData.PRICE }}</div>
      <div class="flex_start tabs">
        <div
          v-for="item in tabList"
          :key="item.id"
          :class="{ active: item.id == current }"
          class="tab"
          @click="onTabChange(item)"
        >
          {{ item.name }}
        </div>
        <!-- <div class="tab">1Y</div> -->
      </div>
    </div>
    <div
      class="echart_box"
      :style="{ height: height + 'px' }"
      v-loading="showLoading"
    >
      <stock-index-echart ref="stockEchart"></stock-index-echart>
    </div>
    <div ref="key_stats" class="key_stats">
      <div class="title">{{ $transform("KEY STATS") }}</div>
      <div v-if="detailType == 'stockIndexDetail'" class="keys_box flex_start">
        <div class="keys_item flex_between">
          <div class="label">{{ $transform("Open") }}</div>
          <div class="data">
            {{ tableData["Open"] ? tableData["Open"] : "-" }}
          </div>
        </div>
        <div class="keys_item flex_between">
          <div class="label">{{ $transform("Prev Close") }}</div>
          <div class="data">
            {{ tableData["Prev Close"] ? tableData["Prev Close"] : "-" }}
          </div>
        </div>
        <div class="keys_item flex_between">
          <div class="label">
            {{ $transform("%Change") }}
          </div>
          <div
            class="data"
            :style="isreduce(tableData['%CHG']) ? 'color: #e8554e' : ''"
          >
            {{ tableData["%CHG"] ? tableData["%CHG"] : "-" }}
          </div>
        </div>
        <div class="keys_item flex_between">
          <div class="label">{{ $transform("Day High") }}</div>
          <div class="data">
            {{ tableData["Day High"] ? tableData["Day High"] : "-" }}
          </div>
        </div>
        <div class="keys_item flex_between">
          <div class="label">{{ $transform("Day Low") }}</div>
          <div class="data">
            {{ tableData["Day Low"] ? tableData["Day Low"] : "-" }}
          </div>
        </div>
      </div>
      <div v-if="detailType == 'stockDetail'" class="keys_box flex_start">
        <div class="keys_item flex_between">
          <div class="label">{{ $transform("Open") }}</div>
          <div class="data">{{ tableData.Open ? tableData.Open : "-" }}</div>
        </div>
        <div class="keys_item flex_between">
          <div class="label">{{ $transform("Prev Close") }}</div>
          <div class="data">
            {{ tableData["Prev Close"] ? tableData["Prev Close"] : "-" }}
          </div>
        </div>
        <div class="keys_item flex_between">
          <div class="label">{{ $transform("%Change") }}</div>
          <div
            class="data"
            :style="isreduce(tableData['%CHG']) ? 'color: #e8554e' : ''"
          >
            {{ tableData["%CHG"] ? tableData["%CHG"] : "-" }}
          </div>
        </div>
        <div class="keys_item flex_between">
          <div class="label">{{ $transform("Day High") }}</div>
          <div class="data">
            {{ tableData["Day High"] ? tableData["Day High"] : "-" }}
          </div>
        </div>
        <div class="keys_item flex_between">
          <div class="label">{{ $transform("Day Low") }}</div>
          <div class="data">
            {{ tableData["Day Low"] ? tableData["Day Low"] : "-" }}
          </div>
        </div>
      </div>
      <div v-if="detailType == 'futureDetail'" class="keys_box flex_start">
        <div class="keys_item flex_between">
          <div class="label">{{ $transform("Open") }}</div>
          <div class="data">{{ tableData.Open ? tableData.Open : "-" }}</div>
        </div>
        <div class="keys_item flex_between">
          <div class="label">{{ $transform("Prev Close") }}</div>
          <div class="data">
            {{ tableData["Prev Close"] ? tableData["Prev Close"] : "-" }}
          </div>
        </div>
        <div class="keys_item flex_between">
          <div class="label">{{ $transform("Exp. Date") }}</div>
          <div class="data">
            {{ tableData["Exp.Date"] ? tableData["Exp.Date"] : "-" }}
          </div>
        </div>
        <div class="keys_item flex_between">
          <div class="label">{{ $transform("Day High") }}</div>
          <div class="data">
            {{ tableData["Day High"] ? tableData["Day High"] : "-" }}
          </div>
        </div>
        <div class="keys_item flex_between">
          <div class="label">{{ $transform("Open Interest") }}</div>
          <div class="data">
            {{ tableData["Open Interest"] ? tableData["Open Interest"] : "-" }}
          </div>
        </div>
        <div class="keys_item flex_between">
          <div class="label">{{ $transform("%Change") }}</div>
          <div
            class="data"
            :style="isreduce(tableData['%CHG']) ? 'color: #e8554e' : ''"
          >
            {{ tableData["%CHG"] ? tableData["%CHG"] : "-" }}
          </div>
        </div>

        <div class="keys_item flex_between">
          <div class="label">{{ $transform("Day Low") }}</div>
          <div class="data">
            {{ tableData["Day Low"] ? tableData["Day Low"] : "-" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StockIndexEchart from "@/components/stock-line/index.vue";
import mixin from "@/libs/mixin";
export default {
  mixins: [mixin],
  components: {
    "stock-index-echart": StockIndexEchart,
  },

  props: {
    detailType: {
      type: String,
      default: "stockIndexDetail",
    },
    tableData: {
      type: Object,
      default: () => {},
    },
    baseInfo: { type: Object, default: () => {} },
  },
  data() {
    return {
      height: 300,
      showLoading: false,
      current: "YTD",
      tabList: [
        {
          name: "YTD",
          id: "YTD",
        },
        {
          name: "1Y",
          id: "1Y",
        },
      ],
    };
  },
  watch: {
    baseInfo() {
      this.changeView(this.$refs.contanier, () => {
        try {
          let ch = this.$refs.contanier.offsetHeight;
          let th = this.$refs.top_box.offsetHeight + 40;
          let h = this.$refs.key_stats.offsetHeight + 20;
          this.height = ch - th - h;
          console.log(111);
        } catch (e) {
          console.log(e);
        }
      });
    },
  },
  mounted() {},
  methods: {
    isreduce(item) {
      if (item) {
        return parseFloat(item) < 0;
      }
      return false;
    },
    onTabChange(item) {
      this.current = item.id;
      this.$emit("tabChange", this.current);
    },
    setData(xData, yData) {
      this.$refs.stockEchart.setData(xData, yData);
    },
    setOption(xData, yData) {
      this.$refs.stockEchart.setOption(xData, yData);
    },
    loadingFn() {
      this.showLoading = true;
    },
    hideLoading() {
      this.showLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
$max-width: 700px;
.stock_index_detail {
  height: 100vh;
  .stock_title {
    font-size: 28px;
    font-family: SF-Pro-Display-Bold;
    font-weight: 300;
    color: #002f6c;
  }
  .stock_name {
    font-size: 20px;
    font-family: SF-Pro-Display-Bold;
    font-weight: 300;
    color: #747474;
    margin-bottom: 20px;
  }
  .time {
    font-size: 16px;
    font-weight: 300;
    color: #171717;
    font-family: SF-Pro-Display-Bold;
  }
  .stock_data {
    font-size: 52px;

    font-weight: 300;
    font-family: SF-Pro-Display-Heavy;
    color: #171717;
  }
  .tabs {
    margin-top: 20px;
    // margin-bottom: 40px;
    .tab {
      font-size: 14px;
      font-weight: 300;
      color: #8c8c8c;
      line-height: 28px;
      padding: 0 7px;
      cursor: pointer;
      &.active {
        background-color: #b4d9ff;
        font-weight: 300;
        color: #005594;
      }
    }
  }
  .key_stats {
    margin-top: 20px;
    .title {
      font-size: 18px;
      font-weight: 300;
      color: #002f6c;
      margin-bottom: 30px;
      font-family: SF-Pro-Display-Bold;
      text-transform: uppercase;
    }
    .keys_box {
      flex-wrap: wrap;
      .keys_item {
        height: 30px;
        width: 30%;
        margin-right: 3%;
        border-bottom: 1px solid #e5e5e5;
        @media screen and (max-width: $max-width) {
          width: 100%;
          margin-right: 0;
        }
        &:nth-child(3n) {
          margin-right: 0;
        }
        .label {
          font-size: 16px;
          font-weight: 300;
          color: #747474;
          font-family: SF-Pro-Display-Bold;
        }
        .data {
          font-size: 16px;
          font-weight: 300;
          color: #171717;
          font-family: SF-Pro-Display-Bold;
        }
      }
    }
  }
  .echart_box {
    position: relative;
    width: 100%;
    height: 400px;
  }
}
</style>
